import { t } from "@/i18n-js/instance";

interface StatusProps {
  status: string;
}

export const Status = ({ status }: StatusProps) => (
  <span className="flex min-h-[1.5rem] items-center gap-2">
    <span className="break-normal capitalize">
      {t(["settings.workflows.table.status", status], {
        defaultValue: status || "─",
      })}
    </span>
  </span>
);
